import { useEffect, useRef } from 'react';

import { devicesCheck } from '@ctct/infrastructure-layer';

export function useOnBeforeUnload(fn: () => void) {
  const ref = useRef<typeof fn>(fn);

  useEffect(() => {
    ref.current = fn;
  }, [fn]);

  useEffect(() => {
    const handler = () => ref.current();

    // Use 'pagehide' for iOS and Safari as 'beforeunload' is unreliable on those platforms
    // https://bugs.webkit.org/show_bug.cgi?id=219102
    const eventName: 'beforeunload' | 'pagehide' =
      devicesCheck.isIOS() || devicesCheck.isSafari() ? 'pagehide' : 'beforeunload';

    window.addEventListener(eventName, handler);

    return () => {
      window.removeEventListener(eventName, handler);
    };
  }, []);
}
